import { MouseEvent, MouseEventHandler } from 'react'
import { Modal } from '../../../component/modal'
import { MediaFile } from '../../../entity'
import { useTranslation } from 'react-i18next'
import { WarrantyStatus } from '../../../enum/warranty-status.enum'
import { PhotoEditor } from './editor/photo-editor'
import { VideoEditor } from './video-editor/video-editor';
import { useSelector } from 'react-redux'
import { State } from '../../../state'
import { UserType } from '../../../enum/user-type.enum'
import './media-file-modal.scss'

interface PhotoModalProps {
    mediaFile: MediaFile
    warrantyStatus: WarrantyStatus
    onCloseClick?: MouseEventHandler
    onDeleteCallback: CallableFunction
    onEditCallback: CallableFunction
}

export const MediaFileModal = (props: PhotoModalProps) => {
    const { t } = useTranslation()
    const { authenticatedUser } = useSelector((state: State) => state.session)

    const onDeleteButtonClick = async (event: MouseEvent) => {
        event.preventDefault()

        if (authenticatedUser?.role !== UserType.REVIEWER) {
            props.onDeleteCallback(props.mediaFile)
        }
    }

    const onEditButtonClick = async (event: MouseEvent) => {
        event.preventDefault()

        if (authenticatedUser?.role !== UserType.REVIEWER) {
            props.onEditCallback(props.mediaFile)
        }
    }

    return (
        <Modal title={t(props.mediaFile.type === 0 ? 'photo_info_modal_title' : 'video_info_modal_title') + ' ' + props.mediaFile.id} onCloseClick={props.onCloseClick}>
            { props.mediaFile.type === 0 ? (
                <PhotoEditor photo={props.mediaFile} editable={false} />
            ) : <div>
                <video controls style={{maxWidth: 500, maxHeight: 500}}>
                    <source src={props.mediaFile.coveredUrl} />
                </video>
            </div> }

            <div className={`photo-modal__buttons ${props.warrantyStatus === WarrantyStatus.ACCEPTED ? 'photo-modal__hidden' : ''}`}>
                {authenticatedUser?.role !== UserType.REVIEWER ? (
                    <>
                        <button className="button button--secondary secondary" onClick={onDeleteButtonClick}>
                            {t('photo_modal_delete_button')}
                        </button>

                        <button className="button" onClick={onEditButtonClick}>
                            {t(props.mediaFile.type === 0 ? 'photo_modal_edit_button' : 'video_modal_edit_button')}
                        </button>
                    </>
                ) : null}
            </div>
        </Modal>
    )
}
